export const FirebaseEvents = {
  PAGE_VIEW: 'page_view',
};

export enum ImageAspectRatio {
  LANDSCAPE = '16:9',
  SQUARE = '4:4',
  TILE = '4:3',
}
